import { ILogger } from 'fitbeat.models';

type DbBuilder = () => any; // types not setup in gym core, should be: PouchDB.Database;

const errorIsNotFound = (e: any): boolean => {
    return e.status === 404;
};

interface IBasicAuthUser {
    password: string;
    roles: string[];
}

export function getDbAuthorizerForRoles(basicAuthUsers: DbBuilder, winston: ILogger, roles: string[]) {
    const authorizeFunction = async (username: string, password: string, callback: any) => {
        try {
            const basicAuthUsersDB = basicAuthUsers();
            const user: IBasicAuthUser = await basicAuthUsersDB.get(username);

            if (!user || user.password !== password) {
                winston.warn(`user ${username} not found or invalid password`);
                return callback(null, false);
            }

            const matchingRoles = user.roles.filter((role: string) => -1 !== roles.indexOf(role));
            const hasMatchingRoles = matchingRoles.length !== 0;
            if (!hasMatchingRoles) {
                winston.warn(`user ${username} attempted with invalid roles ${user.roles} but required ${roles}`);
                return callback(null, false);
            }
            winston.debug(`user ${username} authenticated`);
            callback(null, true);
        } catch (e: any) {
            if (errorIsNotFound(e)) {
                return callback(null, false);
            }
            winston.error(`failed to resolve user: ${username}`);
            return callback(e);
        }
    };
    return authorizeFunction;
}
